import React, { ReactElement } from 'react';

import './description.scss';

const CompanyViewInfoDescription: React.FC<{ text?: string; }> = ({ text }): ReactElement => (
    <div className="company-view-info__description">
        <div className="company-view-info__description-header">
            Opis firmy
        </div>
        {text?.split(/\n+/).map(textLine => (
            <React.Fragment key={Math.random()}>
                {textLine}
                <br />
            </React.Fragment>
        ))}
    </div>
);

export default CompanyViewInfoDescription;
